import React from 'react'
import Example from '../../img/detection_example.jpeg'

const Detection = () => {
  return (
    <img className='detectionImage' src={Example}/>       
  )
}

export default Detection